<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2 px-2">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_search"
            >
              <strong>
                Search
              </strong>
            </label>
            <b-input
              id="filter_search"
              v-model="tableSuppliers.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="px-1"
        >
          <b-button
            type="button"
            variant="primary"
            @click="onShowAddFormSupplier"
          >
            Add Supplier
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="tableSuppliers"
        hover
        responsive
        show-empty
        class="mt-2"
        :per-page="tableSuppliers.perPage"
        :current-page="tableSuppliers.currentPage"
        :items="myProvider"
        :fields="tableSuppliers.fields"
        :sort-by.sync="tableSuppliers.sortBy"
        :sort-desc.sync="tableSuppliers.sortDesc"
        :sort-direction="tableSuppliers.sortDirection"
        :filter="tableSuppliers.filter"
        :filter-included-fields="tableSuppliers.filterOn"
      >
        <template #cell(index)="row">
          {{ tableSuppliers.currentPage * tableSuppliers.perPage - tableSuppliers.perPage + (row.index + 1) }}
        </template>

        <template #cell(active)="row">
          {{ row.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(supplier_name)="row">
          <div class="text-nowrap">
            <strong>{{ row.value }}</strong>
          </div>
        </template>

        <template #cell()="row">
          <div class="text-nowrap">
            {{ row.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditFormSupplier(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSuppliers.perPage"
              :options="tableSuppliers.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSuppliers.currentPage"
            :total-rows="tableSuppliers.totalRows"
            :per-page="tableSuppliers.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-supplier"
      scrollable
      no-close-on-backdrop
      :title="modalSupplierTitle"
      aria-hidden="false"
      @ok="onValidateFormSupplier"
    >
      <ValidationObserver
        ref="formSupplier"
      >
        <form
          novalidate
          @submit.prevent
        >

          <ValidationProvider
            #default="{ errors }"
            name="supplier name"
            vid="supplier_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label for="supplier_name">
                <strong>
                  Supplier
                </strong>
              </label>
              <b-input
                id="supplier_name"
                v-model="supplier.supplier_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter supplier name"
                autocomplete="off"
                :disabled="state.busy"
                switch
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="supplier_address"
            vid="supplier_address"
            rules="max:500"
          >
            <b-form-group>
              <label for="supplier_address">
                <strong>
                  Address
                </strong>
              </label>
              <b-textarea
                id="supplier_address"
                v-model="supplier.supplier_address"
                rows="3"
                max-rows="12"
                placeholder="enter address"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="supplier.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AdminSupplierService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminSuppliers',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Suppliers'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      supplier: {
        id: null,
        supplier_name: null,
        supplier_address: null,
        active: 0
      },
      tableSuppliers: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'supplier_name', label: 'supplier', sortable: true },
          { key: 'supplier_address', label: 'address' },
          { key: 'active', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalSupplierTitle () {
      return this.state.editing ? 'Edit Supplier' : 'Add Supplier'
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async myProvider (ctx) {
      return await AdminSupplierService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter
        })
      ).then(({ data }) => {
        this.tableSuppliers.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        return []
      })
    },

    onShowAddFormSupplier () {
      this.state.editing = false
      this.supplier.id = null
      this.supplier.supplier_name = null
      this.supplier.supplier_address = null
      this.supplier.active = 1
      this.$bvModal.show('modal-supplier')
    },

    onShowEditFormSupplier (supplier) {
      this.state.editing = true
      this.supplier.id = supplier.id
      this.supplier.supplier_name = supplier.supplier_name
      this.supplier.supplier_address = supplier.supplier_address
      this.supplier.active = supplier.active
      this.$bvModal.show('modal-supplier')
    },

    async onValidateFormSupplier (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formSupplier.validate().then(async success => {
        if (success) {
          let text = 'Do you really want to create supplier?'
          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.onPutFormSupplier()
              } else {
                return this.onPostFormSupplier()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            }
          )
        }
      })
    },

    async onPostFormSupplier () {
      return new Promise(resolve => {
        AdminSupplierService.post(this.supplier).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-supplier')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.tableSuppliers.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formSupplier.setErrors(error.message)
          resolve(error)
        })
      })
    },

    async onPutFormSupplier () {
      return new Promise(resolve => {
        AdminSupplierService.put(this.supplier).then(({ data }) => {
          this.$bvModal.hide('modal-supplier')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableSuppliers.localItems, { id: data.supplier.id })
            row.supplier_name = data.supplier.supplier_name
            row.supplier_address = data.supplier.supplier_address
            row.active = data.supplier.active
            row.updated_at = data.supplier.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formSupplier.setErrors(error.message)
          resolve(error)
        })
      })
    }
  }
}
</script>
